import { RefObject, useEffect } from "react";

/**
 * Hook used to detect if a click is triggered outside of the referenced html components.
 * @param refs The array of html component references
 * @param callback The callback function triggered when an outside click is triggered.
 */
function useClickOutside(
    refsOrRef: RefObject<{ contains: (event: EventTarget) => boolean }> | RefObject<{ contains: (event: EventTarget) => boolean }>[],
    callback: (event?: EventTarget) => void
): void {
    const refs = Array.isArray(refsOrRef) ? refsOrRef : [refsOrRef];

    useEffect(() => {
        const clickHandler = (event: MouseEvent): void => {
            if (!refs.some(ref => ref.current?.contains(event.target))) {
                callback(event.target);
            }
        };
        document.addEventListener("mousedown", clickHandler);

        return () => {
            document.removeEventListener("mousedown", clickHandler);
        };
    }, []);
}

export { useClickOutside };
